import { buildProps, numericProp, unknownProp } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue'
import type Checker from './checker.tsx'
import type { PropType } from 'vue/dist/vue'

import type { CheckerLabelPosition } from './types'

export const checkerProps = buildProps({
  name: {
    type: unknownProp,
  },
  disabled: Boolean,
  iconSize: {
    type: numericProp,
  },
  modelValue: {
    type: unknownProp,
  },
  checkedColor: String,
  labelPosition: {
    type: String as PropType<CheckerLabelPosition>,
  },
  labelDisabled: Boolean,
})

export type CheckerProps = ExtractPropTypes<typeof checkerProps>
export type CheckerInstance = InstanceType<typeof Checker>
